export { default as translations } from './translations.json';

export const REASON_CODES = ['damaged', 'not_as_described', 'no_show', 'late', 'other'];
export const DISPUTE_STATUSES = ['open', 'under_review', 'resolved', 'closed'];

/**
 * Get dispute from transaction.
 * @param {Object|null} transaction
 * @returns {Object|null}
 */
export const getDispute = (transaction) =>
  transaction?.attributes?.metadata?.dispute || null;

export const hasOpenDispute = (transaction) => {
  const d = getDispute(transaction);
  return !!d && !['resolved', 'closed'].includes(d.status);
};
